<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-moviesinfo__moviesinfo}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.cartoonCode" placeholder="影片ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('moviesinfo:moviesinfo:save')" type="primary" @click="add()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('moviesinfo:moviesinfo:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="资源id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="url" label="资源url" header-align="center" align="center"  width="350" >
          <template slot-scope="scope">
            <el-button type="success" @click="playVideo(scope.row.url)">播放视频(第一次不播放,记得关了再点击)</el-button>
        </template>
        </el-table-column>
        <el-table-column prop="name" label="第几集或者高清等显示" header-align="center" align="center"></el-table-column>
        <el-table-column prop="moviesName" label="所属影视ID" header-align="center" align="center"></el-table-column>
        <!-- <el-table-column prop="dictName" label="所属分类" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sonDictName" label="所属子分类" header-align="center" align="center"></el-table-column> -->
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('moviesinfo:moviesinfo:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('moviesinfo:moviesinfo:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
      <el-dialog
        title="视频预览"
        :visible.sync="dialogPlay"
        v-model="dialogPlay"
        width="400"
        @close="closeDialog"
        >
        <video v-if="videoUrls!=''" :src="videoUrls" ref="videoRef" width="90%" controls
          style="margin: 30px 70px;"></video>
        <video v-else ref="videoRef" width="90%" style="margin: 30px 70px;" type="audio/wav"
          controls="controls"></video>
        </el-dialog>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './moviesinfo-add-or-update'
import Hls from 'hls.js';
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/moviesinfo/moviesinfo/page',
        getDataListIsPage: true,
        createdIsNeed: false,
        exportURL: '/moviesinfo/moviesinfo/export',
        deleteURL: '/moviesinfo/moviesinfo',
        deleteIsBatch: true
      },
      videoUrls:'',
      dialogPlay: false,
      dataForm: {
        id: '',
        cartoonCode: ''
      }
    }
  },
  watch: { // 监听，当路由发生变化的时候执行
        $route(to, from){
          if(this.$route.query.cartoonCode){
            if(this.dataForm.cartoonCode != this.$route.query.cartoonCode){
              this.dataForm.cartoonCode = this.$route.query.cartoonCode;
            this.getDataList()
            }

          }
        },
    },
  mounted(){
    this.dataForm.cartoonCode = this.$route.query.cartoonCode;
    this.getDataList()
  },
  components: {
    AddOrUpdate
  },
  methods:{
    add(){
      this.addHandleMoviesInfo(this.dataForm.cartoonCode)
    },
    playVideo(url){
      this.videoUrls = ''
				if (url.indexOf("m3u8") != -1) {
					var hls = new Hls();
					hls.loadSource(url);
					hls.attachMedia(this.$refs.videoRef);
					hls.on(Hls.Events.MANIFEST_PARSED, function() {
						this.$refs.videoRef.play();
					});
				} else {
					this.videoUrls = url;
				}

      this.dialogPlay = true;
    },
    closeDialog() {
      this.playVideoUrl = ""; //清空数据 关闭视频播放
    }
  }
}
</script>
